import { Alert } from 'antd';
import useCrud from 'hooks/useCrud';
import { useEffect, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { storeUsers } from 'services/api/admin';

export interface PermissionTipsProps {
  permission: boolean;
  permissionId: General.PermissionId;
  storeId: number | string;
}

function PermissionTips(props: PermissionTipsProps) {
  const { permission, permissionId, storeId } = props;

  const { t } = useTranslate();

  const {
    list: userList = [],
    fetchList: fetchUserList,
    setList: setUserList,
  } = useCrud({
    readList: storeUsers,
  });

  const refsCurrent = { fetchUserList, setUserList };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    if (!permission) {
      refs.current
        .fetchUserList({
          storeId,
          permId: permissionId,
        })
        .catch(() => {});
    }

    return () => {
      refs.current.setUserList([]);
    };
  }, [storeId, permissionId, permission]);

  return userList.length > 0 ? (
    <Alert
      banner
      type="warning"
      message={t('aide.您没有该功能的配置权限，如需修改策略，请联系x操作', {
        x: userList.map(({ name, account }) => `[${name || account}]`).join(' '),
      })}
    />
  ) : (
    <></>
  );
}

export default PermissionTips;
